import { render, staticRenderFns } from "./signaTurePage.vue?vue&type=template&id=a3c5b71c&"
import script from "./signaTurePage.vue?vue&type=script&lang=js&"
export * from "./signaTurePage.vue?vue&type=script&lang=js&"
import style0 from "./signaTurePage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports